import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const KazakhstanFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15234'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15234)'>
				<rect
					width='20'
					height='14'
					fill='#30C6E0'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.99972 9.79995C11.5777 9.79995 12.8569 8.54635 12.8569 6.99995C12.8569 5.45355 11.5777 4.19995 9.99972 4.19995C8.42176 4.19995 7.14258 5.45355 7.14258 6.99995C7.14258 8.54635 8.42176 9.79995 9.99972 9.79995Z'
					fill='#FFCD4B'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M8.83423 12.0046L9.99981 10.2995L11.1654 12.0046L11.4606 9.97276L13.2657 11.0134L12.6321 9.05721L14.7192 9.22726L13.2823 7.73421L15.2379 6.99999L13.2823 6.26578L14.7192 4.77272L12.6321 4.94277L13.2657 2.98659L11.4606 4.02722L11.1654 1.99536L9.99981 3.70046L8.83423 1.99536L8.53899 4.02722L6.73391 2.98659L7.36749 4.94277L5.28045 4.77272L6.71736 6.26578L4.76172 6.99999L6.71736 7.73421L5.28045 9.22726L7.36749 9.05721L6.73391 11.0134L8.53899 9.97276L8.83423 12.0046ZM13.3331 6.99999C13.3331 8.80412 11.8408 10.2667 9.99981 10.2667C8.15886 10.2667 6.66648 8.80412 6.66648 6.99999C6.66648 5.19586 8.15886 3.73332 9.99981 3.73332C11.8408 3.73332 13.3331 5.19586 13.3331 6.99999Z'
					fill='#FFCD4B'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0.953125 1.26668C0.953125 1.08259 1.10236 0.93335 1.28646 0.93335H1.57217C1.75627 0.93335 1.90551 1.08259 1.90551 1.26668V1.53335C1.90551 1.71744 1.75627 1.86668 1.57217 1.86668H1.28646C1.10236 1.86668 0.953125 1.71744 0.953125 1.53335V1.26668ZM0.953125 3.13335C0.953125 2.94925 1.10236 2.80002 1.28646 2.80002H1.57217C1.75627 2.80002 1.90551 2.94925 1.90551 3.13335V3.40002C1.90551 3.58411 1.75627 3.73335 1.57217 3.73335H1.28646C1.10236 3.73335 0.953125 3.58411 0.953125 3.40002V3.13335ZM1.28646 4.66668C1.10236 4.66668 0.953125 4.81592 0.953125 5.00002V5.26668C0.953125 5.45078 1.10236 5.60002 1.28646 5.60002H1.57217C1.75627 5.60002 1.90551 5.45078 1.90551 5.26668V5.00002C1.90551 4.81592 1.75627 4.66668 1.57217 4.66668H1.28646ZM0.953125 6.86668C0.953125 6.68259 1.10236 6.53335 1.28646 6.53335H1.57217C1.75627 6.53335 1.90551 6.68259 1.90551 6.86668V7.13335C1.90551 7.31745 1.75627 7.46668 1.57217 7.46668H1.28646C1.10236 7.46668 0.953125 7.31744 0.953125 7.13335V6.86668ZM1.28646 8.40002C1.10236 8.40002 0.953125 8.54925 0.953125 8.73335V9.00002C0.953125 9.18411 1.10236 9.33335 1.28646 9.33335H1.57217C1.75627 9.33335 1.90551 9.18411 1.90551 9.00002V8.73335C1.90551 8.54926 1.75627 8.40002 1.57217 8.40002H1.28646ZM0.953125 10.6C0.953125 10.4159 1.10236 10.2667 1.28646 10.2667H1.57217C1.75627 10.2667 1.90551 10.4159 1.90551 10.6V10.8667C1.90551 11.0508 1.75627 11.2 1.57217 11.2H1.28646C1.10236 11.2 0.953125 11.0508 0.953125 10.8667V10.6ZM1.28646 12.1334C1.10236 12.1334 0.953125 12.2826 0.953125 12.4667V12.7334C0.953125 12.9174 1.10236 13.0667 1.28646 13.0667H1.57217C1.75627 13.0667 1.90551 12.9174 1.90551 12.7334V12.4667C1.90551 12.2826 1.75627 12.1334 1.57217 12.1334H1.28646ZM1.90551 11.5333C1.90551 11.3493 2.05474 11.2 2.23884 11.2H2.52455C2.70865 11.2 2.85789 11.3493 2.85789 11.5333V11.8C2.85789 11.9841 2.70865 12.1333 2.52455 12.1333H2.23884C2.05474 12.1333 1.90551 11.9841 1.90551 11.8V11.5333ZM2.23884 9.33335C2.05474 9.33335 1.90551 9.48259 1.90551 9.66668V9.93335C1.90551 10.1174 2.05474 10.2667 2.23884 10.2667H2.52455C2.70865 10.2667 2.85789 10.1174 2.85789 9.93335V9.66668C2.85789 9.48259 2.70865 9.33335 2.52455 9.33335H2.23884ZM1.90551 7.80002C1.90551 7.61592 2.05474 7.46668 2.23884 7.46668H2.52455C2.70865 7.46668 2.85789 7.61592 2.85789 7.80002V8.06668C2.85789 8.25078 2.70865 8.40002 2.52455 8.40002H2.23884C2.05474 8.40002 1.90551 8.25078 1.90551 8.06668V7.80002ZM2.23884 5.60002C2.05474 5.60002 1.90551 5.74925 1.90551 5.93335V6.20002C1.90551 6.38411 2.05474 6.53335 2.23884 6.53335H2.52455C2.70865 6.53335 2.85789 6.38411 2.85789 6.20002V5.93335C2.85789 5.74925 2.70865 5.60002 2.52455 5.60002H2.23884ZM1.90551 4.06668C1.90551 3.88259 2.05474 3.73335 2.23884 3.73335H2.52455C2.70865 3.73335 2.85789 3.88259 2.85789 4.06668V4.33335C2.85789 4.51745 2.70865 4.66668 2.52455 4.66668H2.23884C2.05474 4.66668 1.90551 4.51744 1.90551 4.33335V4.06668ZM2.23884 1.86668C2.05474 1.86668 1.90551 2.01592 1.90551 2.20002V2.46668C1.90551 2.65078 2.05474 2.80002 2.23884 2.80002H2.52455C2.70865 2.80002 2.85789 2.65078 2.85789 2.46668V2.20002C2.85789 2.01592 2.70865 1.86668 2.52455 1.86668H2.23884Z'
					fill='#FFCD4B'
				/>
			</g>
		</svg>
	);
};

export default KazakhstanFlagIcon;
